import { render, staticRenderFns } from "./deptTab.vue?vue&type=template&id=1e6f9d3d&scoped=true&"
import script from "./deptTab.vue?vue&type=script&lang=js&"
export * from "./deptTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6f9d3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6f9d3d')) {
      api.createRecord('1e6f9d3d', component.options)
    } else {
      api.reload('1e6f9d3d', component.options)
    }
    module.hot.accept("./deptTab.vue?vue&type=template&id=1e6f9d3d&scoped=true&", function () {
      api.rerender('1e6f9d3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/role/deptTab.vue"
export default component.exports